export const cloneTemplate = selector => {
    return document.querySelector(selector).content.cloneNode(true);
};
